import { goToLink } from "@actions/common";
import { showAlert } from "@components/alert/action";
import { openGame } from "@pages/casino/utils";
import CloseIcon from "@pages/profile-v2/assets/icons/CloseIcon.jsx";
import PlayNowIcon from "@pages/profile-v2/assets/icons/PlayNowIcon.jsx";
import SuccessIcon from "@pages/profile-v2/assets/icons/SuccessIcon.jsx";
import React from "react";
import ReactDOM from "react-dom";
import { Translate } from "react-localize-redux";
import { connect } from "react-redux";
import {
	AlertWrapper,
	ButtonWrapper,
	ContentDescription,
	ContentMsg,
	ContentWrapper,
	Modal,
	PlayNowButton,
	Title,
	TitleWrapper,
} from "./elements";

const Alert = ({ type, data, goToLink, showAlert, open, onClose }) => {
	const handlePlayNowClick = () => {
		openGame(data.data.game, goToLink, showAlert);
	};

	const alertElement = (
		<Translate>
			{({ translate }) => (
				<Modal>
					<AlertWrapper>
						<TitleWrapper>
							<SuccessIcon />
							<Title>
								{type === "Freespin"
									? translate("FREESPIN_CONFIRMED")
									: translate("BONUS_CONFIRMED")}
							</Title>
						</TitleWrapper>
						<ContentWrapper>
							<ContentMsg>
								{type === "Freespin"
									? translate("FREESPIN_CONFIRM_TEXT")
									: translate("BONUS_CONFIRM_TEXT")}
							</ContentMsg>
							<ContentDescription>{translate("GOOD_LUCK")}</ContentDescription>
						</ContentWrapper>
					</AlertWrapper>
					<ButtonWrapper>
						<CloseIcon
							className="modal-close-icon"
							onClick={onClose}
						/>
						{type === "Freespin" ? (
							<PlayNowButton onClick={handlePlayNowClick}>
								<PlayNowIcon />
								{translate("PLAY_NOW")}
							</PlayNowButton>
						) : null}
					</ButtonWrapper>
				</Modal>
			)}
		</Translate>
	);

	if (open) {
		return ReactDOM.createPortal(alertElement, document.body);
	} else {
		return null;
	}
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
	goToLink,
	showAlert,
};

export default connect(mapStateToProps, mapDispatchToProps)(Alert);
